import React from 'react';

interface PainItem {
  icon: string;
  text: string;
}

interface SectionPainProps {
  title: string;
  intro: string;
  items: PainItem[];
}

const SectionPain: React.FC<SectionPainProps> = ({ title, intro, items }) => (
  <section className="lp-section lp-section--pain" aria-labelledby="pain-title">
    <div className="lp-container">
      <h2 id="pain-title">{title}</h2>
      <p className="lp-intro">{intro}</p>
      <ul className="lp-list lp-list--pain">
        {items.map((item, i) => (
          <li key={i}>
            <i className={item.icon} aria-hidden="true" />
            <span>{item.text}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default SectionPain;
